import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { ExternalLink, Info } from "react-feather";
import { IOpenDataProduct } from "../../interfaces";

const HINTS = {
  productUrl:
    "Affiliate link. Goes through the network's tracker and redirects to the product page — use this to check tracking works.",
  merchantUrl:
    "The merchant's own product page URL, straight from their feed — use this to check the product page itself is real and live.",
};

const LinkRow: React.FC<{ label: string; href: string | null; hint: string }> = ({
  label,
  href,
  hint,
}) => (
  <div className="d-flex align-items-center gap-1">
    {href ? (
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        className="d-inline-flex align-items-center gap-1"
      >
        {label} <ExternalLink size={12} />
      </a>
    ) : (
      <span className="text-muted">{label} — none</span>
    )}
    <OverlayTrigger
      placement="top"
      overlay={<Tooltip>{hint}</Tooltip>}
    >
      <button
        type="button"
        aria-label={`What is the ${label.toLowerCase()}?`}
        className="btn btn-link p-0 text-muted d-inline-flex align-items-center border-0"
      >
        <Info size={12} />
      </button>
    </OverlayTrigger>
  </div>
);

/** The two links mean different things, so never collapse them into one. */
export const ProductLinks: React.FC<{ product: IOpenDataProduct }> = ({
  product,
}) => (
  <div className="d-flex flex-column gap-1">
    <LinkRow
      label="Merchant page"
      href={product.merchantUrl}
      hint={HINTS.merchantUrl}
    />
    <LinkRow
      label="Affiliate link"
      href={product.productUrl}
      hint={HINTS.productUrl}
    />
  </div>
);
